import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { iframeUtils } from "@kaihong/utils/lib/iframePostMessage";
import dataJson from "@/../public/data.json";
import "./index.less";
import { getEnable, goLogin } from "@/utils";

const prefix = "physicalModel";

function PhysicalModel() {
  const { product_detail } = dataJson;
  const { id } = useParams();

  const [iframeUrl, setIframeUrl] = useState("");
  const enableQuery = getEnable() ? "&enable=true" : "";
  useEffect(() => {
    const origin = window.location.origin;
    setIframeUrl(
      `${origin}/sub-app/khlinks/#/khlinks/external/Instance/${id}?type=productModel&inIframe=true${enableQuery}`
    );
    iframeUtils.onMessage("login", (data) => {
      console.log("监听iframe页面发送的消息", data);
      goLogin();
    });
  }, [id]);

  return (
    <div className={prefix}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-header`}>
          <div className={`${prefix}-header-text`}>
            <div className={`${prefix}-header-title`}>{product_detail.physical_model.detail_title_text}</div>
            <div className={`${prefix}-header-tip`}>{product_detail.physical_model.info_tip}</div>
          </div>
        </div>
        <div className={`${prefix}-content`}>
          <iframe src={iframeUrl} style={{ width: "100%", height: "100%" }} id="myIframe" name="login" />
        </div>
      </div>
    </div>
  );
}

export default PhysicalModel;
